import { reverse, routing } from './routing';
export const getProductLink = (productType, productId) => {
    if (productType === 'COMBINED') {
        return reverse(routing.products.combined.combinedId.self, { combinedId: productId });
    }
    if (productType === 'BUNDLE') {
        return reverse(routing.products.bundle.bundleId.self, { bundleId: productId });
    }
    return reverse(routing.products.all.product.self, { productId });
};
